@if (blockGridOptions && blockGridOptions.data) {
  <lm-block-grid
    [showEmptyMessage]="showEmptyMessage"
    [selectionMode]="selectionMode"
    [emptyMessageOptions]="emptyMessage"
    [automationId]="listSpec?.busListSpec?.automationId"
  >
    <ng-container content>
      @for (data of blockGridOptions.data; track data; let i = $index) {
        <lm-block-item
          [blockGridOptions]="blockGridOptions"
          [data]="data"
          [populateTooltip]="true"
          [width]="'100'"
          [content]="'image-item'"
          [automationId]="listSpec?.busListSpec?.automationId"
          [index]="i"
          (contextMenu)="onContextMenu($event)"
          (itemActivated)="onItemActivated($event)"
          (itemSelected)="onSelected($event)"
          (itemUnSelected)="onUnSelected($event)"
          (itemDoubleClicked)="onDoubleClick($event)"
          #LMBlockItem
        ></lm-block-item>
      }
    </ng-container>
    <ng-container pager>
      @if (listSpec && !showAsMingleWidget) {
        <lm-list-pager-wrapper
           id="{{testVersion1 ? listSpec.busListSpec.id + '_pager' : null}}"
           class="scrollable-flex-footer"
           [attributes]="pagerIdAttributes"
           [smallPageSizeSelector]="true"
           [pageSizeMenuSettings]="{ attachToBody: true }"

           [enableFirstButton]="hasFirstPage"
           [enablePreviousButton]="hasPreviousPage"
           [enableNextButton]="hasNextPage"
           [enableLastButton]="hasLastPage"

           [firstPageTooltip]="firstPageButtonTooltip"
           [previousPageTooltip]="previousPageButtonTooltip"
           [nextPageTooltip]="nextPageButtonTooltip"
           [lastPageTooltip]="lastPageButtonTooltip"

           [showPageSizeSelector]="showPageSizeSelector"
           [pageSize]="pageSize"
           [pageSizes]="pageSizes"

           (firstPage)="onFirstPage()"
           (previousPage)="onPreviousPage()"
           (nextPage)="onNextPage()"
           (lastPage)="onLastPage()"
           (pageSizeChange)="onPageSizeChange($event)"
        ></lm-list-pager-wrapper>
      }
    </ng-container>
  </lm-block-grid>
}